import { useQuery } from "@tanstack/react-query";
import { getSampleQuestions } from "@/services/apis/sampleQuestionsApi";

export const useSampleQuestions = (currentUser: any) => {
  const query = useQuery({
    queryKey: ["questions"],
    queryFn: () => getSampleQuestions(),
    enabled: !!currentUser,
    staleTime: Infinity, // Data will never become stale
    gcTime: Infinity, // Cache will never be garbage collected
    refetchOnMount: false, // Don't refetch when component mounts
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false,
    retryOnMount: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    retry: false,
    //@ts-ignore
    structuralSharing: (prev, next: any) => {
      return next?.sample_questions || next;
    },
  });

  return {
    sampleQuestions: query.data,
    sampleQuestionsLoading: query.isLoading,
    sampleQuestionsError: query.error,
    refetchSampleQuestions: query.refetch,
  };
};
